import React from 'react';

const OPPlusTransitionReminder = () =>
  React.createElement(
    'op-plus-legacy-notifyer',
    {
      type: 'reminder',
    },
    null,
  );

export default OPPlusTransitionReminder;
